/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "button_add": [{
    "type": 0,
    "value": "Lägg till"
  }],
  "button_remove_all": [{
    "type": 0,
    "value": "Ta bort alla"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var svSE = Object.assign(TranslationProviderComponent, {
  translations
});

export { svSE as s };
//# sourceMappingURL=sv-SE-D7mzFbvC.js.map
